import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQ = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqItems = [
    { 
      question: t('faq.q1'),
      answer: t('faq.a1')
    },
    { 
      question: t('faq.q2'),
      answer: t('faq.a2')
    },
    { 
      question: t('faq.q3'),
      answer: t('faq.a3')
    },
    { 
      question: t('faq.q4'),
      answer: t('faq.a4')
    },
    { 
      question: t('faq.q5'),
      answer: t('faq.a5')
    },
    { 
      question: t('faq.q6'),
      answer: t('faq.a6')
    }
  ];

  return (
    <section id="faq" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-primary mb-6">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-center text-primary mb-12">
            {t('faq.subtitle')}
          </p>

          <div className="space-y-4">
            {faqItems.map((item, index) => (
              <div key={index} className="bg-background rounded-lg overflow-hidden">
                <button
                  className="w-full py-4 px-6 text-left font-medium focus:outline-none flex justify-between items-center"
                  onClick={() => toggleAccordion(index)}
                >
                  <span className="text-primary">{item.question}</span>
                  <span className="text-secondary transform transition-transform duration-200">
                    {activeIndex === index ? '−' : '+'}
                  </span>
                </button>
                <div
                  className={`transition-max-height duration-300 ease-in-out overflow-hidden ${
                    activeIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="p-6 pt-0 text-primary">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;